<template>
    <div class="widget-calendar">
        <dashboardCard heading='Gc Pause Detail' :data1="memoryAfterGc" :data2="memoryMax">
        </dashboardCard>
    </div>
</template>
<script>
import dashboardCard from "./CardData.vue";
export default {
    name: "JvmMemoryUsage",
    components: {
        dashboardCard
    },
    data() {
        return {
            memoryAfterGc: {},
            memoryMax: {},
        };
    },
    methods: {
        getMemoryMax(dataType) {
            let data = {
                type: dataType
            };
            this.$store.dispatch("techDashboardStore/getTechData", data, { root: true })
                .then(response => {
                    const bytes = response.server.data[0].value;
                    this.memoryMax.value = this.formatBytes(bytes);
                    this.memoryMax.name = 'Max';
                    this.memoryMax.description = 'The maximum available memory that the JVM can use.';
                })
                .catch(error => {
                    console.log(error);
                });
        },
        getGcMemoryAfterGc(dataType) {
            let data = {
                type: dataType
            };
            this.$store.dispatch("techDashboardStore/getTechData", data, { root: true })
                .then(response => {
                    this.memoryAfterGc.value = (response.server.data[0].value).toFixed(2);
                    this.memoryAfterGc.name = 'After Gc';
                    this.memoryAfterGc.description = 'The amount of used memory left after a garbage collection cycle.';
                })
                .catch(error => {
                    console.log(error);
                });
        },
        formatBytes(bytes) {
            const gigabytes = bytes / (1024 ** 3);
            const formattedGB = gigabytes.toFixed(2);
            return formattedGB;
        },
    },
    mounted() {
        this.getMemoryMax("MEMORY_MAX");
        this.getGcMemoryAfterGc("MEMORY_AFTER_GC");
    }
};
</script>